import { ButtonPrimary, IconPlay, } from '@spotify-internal/encore-web';
import React, { useState } from 'react';
import styled from 'styled-components';
const PlayButtonWrapper = styled.div `
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  position: relative;
  cursor: pointer;
`;
export const CenteredPlayButton = ({ play, colorSet, isHover, }) => {
    const [growButton, setGrowButton] = useState(false);
    return (React.createElement(PlayButtonWrapper, { onMouseEnter: () => setGrowButton(true), onMouseLeave: () => setGrowButton(false), onClick: play },
        React.createElement(ButtonPrimary, { style: { filter: 'drop-shadow(0 0 6px rgba(0, 0, 0, 0.2))' }, UNSAFE_colorSet: colorSet, iconOnly: IconPlay, buttonSize: "lg", hover: growButton || isHover, onClick: play, "aria-label": "play" })));
};
